import { useState, useEffect } from 'react';
import styles from './Header.module.css'
import CodeAblaze from '../../assets/CodeAblaze-Transparent.png';
import { Link } from 'react-router-dom';

function Header() {

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const scrollYRem = window.scrollY / remSize;

      setScrolled(scrollYRem > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  return (
    <div className={styles.Header}>
      <div className={styles.ColoredBackground}>
        <div className={styles.ImageContainer}>
          <Link to="/">
            <img src={CodeAblaze} alt='logo' />
          </Link>
        </div>
      </div>
      <div className={scrolled ? styles.InvisibleBar : styles.InvisibleBarScrolled}>
        <div className={styles.NavigationLinks}>
          <div>
            <Link to="/">
              <button>
                <h2>Home</h2>
              </button>
            </Link>
          </div>
          <div>
            <Link to="/program">
              <button>
                <h2>Program</h2>
              </button>
            </Link>
          </div>
          <div>
            <Link to="/about">
              <button>
                <h2>About</h2>
              </button>
            </Link>
          </div>
          <div>
            <Link to="/contact">
              <button>
                <h2>Contact</h2>
              </button>
            </Link>
          </div>
          <div>
            <Link to="/join">
              <button>
                <h2>Join</h2>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
